import {procedures, process} from '@mep/pae-commons';

const {PROCEDURE_IDENTIFIERS} = procedures;
const {PROCESS_IDENTIFIERS} = process;

export const CACHE_KEY_LIST_PROCEDURE = 'procedures';
export const CACHE_KEY_PROCEDURE = 'procedure-one';
export const ROUTE_PATH_PROCEDURE = '/company/procedures';
export const TRANSLATION_PREFIX_PROCEDURE = 'procedure';
export const SECURITY_KEY_PROCEDURE = 'PROCEDURE';

export const TRANSLATION_PREFIX_PROCESSED_PROCEDURE = 'processed_procedure';

export const CACHE_KEY_LIST_PROCEDURE_BACK_MODAL = 'procedure-reason-back-dialog';

export const PROCEDURE_STEPS = [
  PROCEDURE_IDENTIFIERS.MEP_REVISION,
  PROCEDURE_IDENTIFIERS.NOTARY_REGISTER,
  PROCEDURE_IDENTIFIERS.COMMERCIAL_REGISTER,
  PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS,
];

export const TCP_PROCEDURE_STEPS = [
  PROCEDURE_IDENTIFIERS.ONAT_VERIFICATION,
  PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS,
];

export const PROPOSAL_REQUEST_TCP_STEPS = [
  PROCESS_IDENTIFIERS.BANK_CREDIT_ACCOUNT_OPEN,
  PROCESS_IDENTIFIERS.COMMERCIAL_REGISTER,
  PROCESS_IDENTIFIERS.ONAT_VERIFICATION,
  PROCESS_IDENTIFIERS.COMPANY_CREATED
];

export const PROPOSAL_REQUEST_TCP_STEPS_ORDER = {
  [PROCESS_IDENTIFIERS.BANK_CREDIT_ACCOUNT_OPEN]: 1,
  [PROCESS_IDENTIFIERS.COMMERCIAL_REGISTER]: 2,
  [PROCESS_IDENTIFIERS.ONAT_VERIFICATION]: 3,
  [PROCESS_IDENTIFIERS.COMPANY_CREATED]: 4
};
